module.exports = __webpack_public_path__ + "static/media/18-30woman.3d1369ae.svg";